import { createTheme } from '@mui/material';

const theme = createTheme({
    palette: {
        primary: {
            main: '#1e3a8a',
        },
        secondary: {
            main: '#555D7E',
        },
        background: {
            // default: '#FAF8FF',
            // paper: '#FAF8FF',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: 999,
                    boxShadow: 'none',
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    '&.MuiInputLabel-shrink': {
                        fontWeight: 500,
                    },
                },
            },
        },
        MuiTooltip: {
            defaultProps: {
                placement: 'top',
            },
        },
    },
});

export default theme;
